import { Controller, Control } from 'react-hook-form';
import { DecomPolicyFormValues } from '../../decom-policy-form-layout.tsx';
import { VAULT_DATA_SCOPE_OPTIONS } from '../../../../../../../types.ts';

import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';

export type VaultDataScopeTypes =
  | 'UNKNOWN'
  | 'ALL_DATA'
  | 'HELD_DATA'
  | 'UNPROCESSED_DATA';

interface VaultDataScopeSelectProps {
  day: number;
  idx: number;
  control: Control<DecomPolicyFormValues>;
  defaultValue?: VaultDataScopeTypes;
}

export default function VaultDataScopeSelect({
  day,
  idx,
  control,
  defaultValue = 'ALL_DATA',
}: VaultDataScopeSelectProps) {
  return (
    <Controller
      name={`actions.${day}.actions.${idx}.dataScope`}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <FormControl sx={{ minWidth: 350 }} size="small">
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Source
          </Typography>
          <Select {...field} value={field.value || ''}>
            {VAULT_DATA_SCOPE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
}
